// import './src/lib/log'
import React from 'react'
import { Provider } from 'react-redux'

import { AuthProvider } from './src/components/auth/AuthContext'
import ApolloClientProvider from './src/lib/apollo/ApolloClientProvider'
import store from './src/state/store'

global.isSSR = false

export const wrapRootElement = ({ element }) => (
  <AuthProvider>
    <Provider store={store}>
      <ApolloClientProvider>{element}</ApolloClientProvider>
    </Provider>
  </AuthProvider>
)
